// Specialist Referrals & Lab Phlebotomy — Endpoint Error Logger
// Centraliza el logging de errores HTTP para debugging sin exponer PHI

const MODULE_TAG = "[SR/Lab Service]";

/**
 * Logea errores de endpoints de forma consistente.
 * NO logea request bodies para cumplir HIPAA (evitar PHI en consola).
 *
 * @param {string} functionName - Nombre de la función que falló
 * @param {string} method - Método HTTP (GET, POST, PUT, DELETE)
 * @param {string} url - URL del endpoint
 * @param {Error} error - Error de axios o genérico
 */
export const logEndpointError = (functionName, method, url, error) => {
  const status = error?.response?.status || "N/A";
  const serverMessage =
    error?.response?.data?.message || error?.message || "Unknown error";
  const resultCode = error?.response?.data?.result;

  console.error(
    `${MODULE_TAG} ${functionName} FAILED\n` +
      `  Method:  ${method}\n` +
      `  URL:     ${url}\n` +
      `  Status:  ${status}\n` +
      `  Result:  ${resultCode !== undefined ? resultCode : "N/A"}\n` +
      `  Message: ${serverMessage}`
  );
};
